import * as Sentry from '@sentry/react-native'
import React, { useEffect, useState } from 'react'
import { LogBox } from 'react-native'
import 'react-native-gesture-handler'
import 'react-native-reanimated'
import { Store } from 'redux'
import { env } from './environment'
import { withBootApp } from './hoc/withBootApp'
import { withRedux } from './hoc/withRedux'
import { withSafeArea } from './hoc/withSafeArea'
import { withTranslation } from './hoc/withTranslation'
import { storeManager } from './lib/storeManager'
import { MainNavigationContainer } from './navigation'
import { RootState } from './redux/reducers'
import { store as reduxStore } from './redux/store'

if (env().ENV !== 'local') {
  Sentry.init({
    dsn: env().sentryDsn,
    environment: env().ENV,
    tracesSampleRate: 1.0,
  })
}

LogBox.ignoreLogs(['componentWillReceiveProps', 'componentWillMount'])

// const enhance = compose(withRedux, withTranslation, withSafeArea, withBootApp)
// const AppContainer = enhance(MainNavigationContainer)

const AppContainer = withRedux(withTranslation(withSafeArea(withBootApp(MainNavigationContainer))))

const App = () => {
  const [store, setStore] = useState<Store<RootState> | undefined>()
  useEffect(() => {
    storeManager.store = reduxStore
    const newStore = storeManager.store
    setStore(newStore)
  }, [])

  if (!store) {
    return null
  }

  return <AppContainer />
}

export default App
